import { goBack } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import sortBy from 'lodash/sortBy'

import { fetchServicing, updateServicing } from '../../actions/servicings'
import { fetchWorkOrder } from '../../actions/work-orders'
import { fetchLocation } from '../../actions/locations'

import ServicingLabelSelectForm from '../../components/servicing-labels/servicing-label-select-form'

const mapStateToProps = (state, ownProps) => {
  const servicing = state.servicings[ownProps.params.areaId]
  const workOrder = state.workOrders[servicing.workOrderId]

  if (!workOrder) return { loading: true }

  const selectedLabels = sortBy(servicing.servicingLabels, 'name').map(label => label.id)

  return {
    locationId: workOrder.location,
    initialValues: {
      servicingLabelIds: selectedLabels
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  dispatch(fetchServicing(ownProps.params.areaId))
    .then((action) => {
      const workOrderId = action.payload.entities.servicings[action.payload.result].workOrderId

      return dispatch(fetchWorkOrder(workOrderId))
    }).then((action) => {
      const locationId = action.payload.entities.workOrders[action.payload.result].location

      dispatch(fetchLocation(locationId))
    })

  return {
    onSubmit (data) {
      dispatch(updateServicing(ownProps.params.areaId, data))
        .then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    form: 'manageLabels',
    fields: ['servicingLabelIds']
  },
  mapStateToProps,
  mapDispatchToProps
)(ServicingLabelSelectForm)



// WEBPACK FOOTER //
// ./src/containers/servicing-labels/servicing-label-select-form-container.js